import { gatewayHttpClient } from '@/infrastructure/http/httpClient';

import { IPartnerListItem, IWhoamiResponse } from '../interfaces/user';

class AuthRepository {
  async whoami(): Promise<IWhoamiResponse | null> {
    const response = await gatewayHttpClient.get<IWhoamiResponse>('/auth/whoami');

    if (!response.partnerId) {
      return null;
    }

    return response;
  }

  async getPartnersList(): Promise<Array<IPartnerListItem>> {
    return gatewayHttpClient.get<Array<IPartnerListItem>>('/users/partners/list');
  }

  async switchPartner(partnerId: string): Promise<IWhoamiResponse> {
    return gatewayHttpClient.patch<IWhoamiResponse>('/users/partners/switch', {
      body: { partnerId },
    });
  }
}

export const authRepository = new AuthRepository();
